import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import styles from "./WhatsappWidgetStep3.module.css";

const Step3UI = ({ responsedata }) => {
  const [copied, setCopied] = useState(false);

  // HTML template
  const htmlTemplate = `<!DOCTYPE html>
<html>
  <head>
    <title>WhatsApp Widget</title>
  </head>
  <body>
    <!-- WhatsApp Widget Script -->
${responsedata || "    // Script not generated yet"}
  </body>
</html>`;

  // Only the script code
  const scriptCode = responsedata || "// Script not generated yet";

  const handleCopy = async () => {
    try {
      // Copy only the script
      await navigator.clipboard.writeText(scriptCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="card shadow-lg rounded-4 p-4">
      <h3 className="mb-3"  style={{ textAlign: "left" }}> Step 3 – Embed WhatsApp Widget</h3>
      <p className="mb-4" style={{ textAlign: "left" }}>
        Copy the code below and paste it inside your website’s.<code>&lt;body&gt;</code>
      </p>

      {copied && (
        <div className="alert alert-success py-1 text-center" role="alert">
          Script code copied to clipboard!
        </div>
      )}

      <div className={styles.codeContainer}>
        <pre className={styles.codeBlock}>
          <code>{htmlTemplate}</code>
        </pre>
      </div>

      <div className="d-flex justify-content-center mt-3">
        <button className="btn btn-success btn-sm" onClick={handleCopy}>
          <FaCopy className="me-2" />
          {copied ? "Copied" : "Copy Script"}
        </button>
      </div>
    </div>
  );
};

export default Step3UI;
